var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackshine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 523,
    height: 312,
    viewBox: "0 0 523 312",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    clipPath: "url(#clip0_1038_6026)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M263.326 155.719L270.428 311.04H252.497L259.599 155.719H263.326Z",
    fill: "url(#paint0_radial_1038_6026)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.295 155.527L314.321 307.941L296.642 309.746L259.63 155.903L263.295 155.527Z",
    fill: "url(#paint1_radial_1038_6026)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.215 155.348L356.682 300.384L339.772 303.943L259.71 156.087L263.215 155.348Z",
    fill: "url(#paint2_radial_1038_6026)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.086 155.176L396.387 288.714L380.731 293.93L259.839 156.26L263.086 155.176Z",
    fill: "url(#paint3_radial_1038_6026)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.914 155.021L432.169 273.175L418.223 279.894L260.018 156.413L262.914 155.021Z",
    fill: "url(#paint4_radial_1038_6026)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.692 154.887L462.927 254.318L451.078 262.343L260.232 156.55L262.692 154.887Z",
    fill: "url(#paint5_radial_1038_6026)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.44 154.775L488.04 232.621L478.638 241.723L260.491 156.66L262.44 154.775Z",
    fill: "url(#paint6_radial_1038_6026)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.157 154.689L506.531 208.701L499.841 218.616L260.768 156.746L262.157 154.689Z",
    fill: "url(#paint7_radial_1038_6026)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.856 154.633L518.042 183.178L514.273 193.629L261.069 156.801L261.856 154.633Z",
    fill: "url(#paint8_radial_1038_6026)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.542 154.609L522.137 156.974L521.381 167.653L261.382 156.826L261.542 154.609Z",
    fill: "url(#paint9_radial_1038_6026)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.229 154.615L518.712 130.695L520.987 141.3L261.702 156.82L261.229 154.615Z",
    fill: "url(#paint10_radial_1038_6026)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.921 154.658L507.939 105.1L513.19 115.323L262.01 156.777L260.921 154.658Z",
    fill: "url(#paint11_radial_1038_6026)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.626 154.726L490.119 81.0195L498.186 90.5654L262.299 156.709L260.626 154.726Z",
    fill: "url(#paint12_radial_1038_6026)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.355 154.824L465.664 59.0449L476.326 67.6424L262.569 156.61L260.355 154.824Z",
    fill: "url(#paint13_radial_1038_6026)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.122 154.948L435.262 39.8496L448.212 47.2461L262.809 156.482L260.122 154.948Z",
    fill: "url(#paint14_radial_1038_6026)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.919 155.096L399.96 24.0215L414.816 30.0077L263.006 156.34L259.919 155.096Z",
    fill: "url(#paint15_radial_1038_6026)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.765 155.263L360.667 11.9941L377.005 16.3976L263.159 156.174L259.765 155.263Z",
    fill: "url(#paint16_radial_1038_6026)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.661 155.434L318.434 4.05469L335.787 6.74601L263.264 155.994L259.661 155.434Z",
    fill: "url(#paint17_radial_1038_6026)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.611 155.625L274.671 0.470703L292.534 1.37602L263.319 155.81L259.611 155.625Z",
    fill: "url(#paint18_radial_1038_6026)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.611 155.81L230.397 1.37602L248.26 0.470703L263.319 155.625L259.611 155.81Z",
    fill: "url(#paint19_radial_1038_6026)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.661 155.994L187.137 6.74601L204.49 4.05469L263.264 155.434L259.661 155.994Z",
    fill: "url(#paint20_radial_1038_6026)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.765 156.174L145.92 16.3976L162.258 11.9941L263.16 155.263L259.765 156.174Z",
    fill: "url(#paint21_radial_1038_6026)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.919 156.34L108.115 30.0077L122.965 24.0215L263.006 155.096L259.919 156.34Z",
    fill: "url(#paint22_radial_1038_6026)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.122 156.482L74.7185 47.2461L87.6625 39.8496L262.809 154.948L260.122 156.482Z",
    fill: "url(#paint23_radial_1038_6026)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.355 156.61L46.5981 67.6424L57.2608 59.0449L262.569 154.824L260.355 156.61Z",
    fill: "url(#paint24_radial_1038_6026)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.626 156.709L24.7383 90.5654L32.8121 81.0195L262.299 154.726L260.626 156.709Z",
    fill: "url(#paint25_radial_1038_6026)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.921 156.777L9.73413 115.323L14.9917 105.1L262.01 154.658L260.921 156.777Z",
    fill: "url(#paint26_radial_1038_6026)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.229 156.82L1.93701 141.3L4.2122 130.695L261.702 154.615L261.229 156.82Z",
    fill: "url(#paint27_radial_1038_6026)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.542 156.826L1.54961 167.653L0.787109 156.974L261.382 154.609L261.542 156.826Z",
    fill: "url(#paint28_radial_1038_6026)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.856 156.801L8.6518 193.629L4.87622 183.178L261.069 154.633L261.856 156.801Z",
    fill: "url(#paint29_radial_1038_6026)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.157 156.746L23.084 218.616L16.3999 208.701L260.768 154.689L262.157 156.746Z",
    fill: "url(#paint30_radial_1038_6026)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.44 156.66L44.2925 241.723L34.8843 232.621L260.491 154.775L262.44 156.66Z",
    fill: "url(#paint31_radial_1038_6026)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.692 156.55L71.847 262.343L59.9976 254.318L260.233 154.887L262.692 156.55Z",
    fill: "url(#paint32_radial_1038_6026)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.913 156.413L104.702 279.894L90.7554 273.175L260.017 155.021L262.913 156.413Z",
    fill: "url(#paint33_radial_1038_6026)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.086 156.26L142.193 293.93L126.544 288.714L259.839 155.176L263.086 156.26Z",
    fill: "url(#paint34_radial_1038_6026)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.215 156.087L183.153 303.943L166.242 300.384L259.71 155.348L263.215 156.087Z",
    fill: "url(#paint35_radial_1038_6026)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.295 155.903L226.283 309.746L208.61 307.941L259.63 155.527L263.295 155.903Z",
    fill: "url(#paint36_radial_1038_6026)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1038_6026",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(261.462 233.379) rotate(90) scale(77.6604 8.96548)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB143"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB143",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1038_6026",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(286.975 232.637) rotate(90) scale(77.1092 27.3453)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB143"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB143",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_1038_6026",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(308.196 229.645) rotate(90) scale(74.2978 48.4861)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB143"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB143",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_1038_6026",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(328.113 224.553) rotate(90) scale(69.3771 68.2741)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB143"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB143",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_1038_6026",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(346.094 217.458) rotate(90) scale(62.4363 86.0759)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB143"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB143",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_1038_6026",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(361.58 208.615) rotate(90) scale(53.728 101.347)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB143"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB143",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_1038_6026",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(374.266 198.249) rotate(90) scale(43.4738 113.775)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB143"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB143",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_1038_6026",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(383.649 186.653) rotate(90) scale(31.9633 122.882)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB143"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB143",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_1038_6026",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(389.556 174.131) rotate(90) scale(19.4983 128.487)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB143"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB143",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_1038_6026",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(391.76 161.131) rotate(90) scale(6.522 130.378)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB143"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB143",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_1038_6026",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(391.108 143.758) rotate(90) scale(13.0625 129.879)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB143"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB143",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_1038_6026",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(387.056 130.938) rotate(90) scale(25.8386 126.135)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB143"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB143",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_1038_6026",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(379.406 118.864) rotate(90) scale(37.8448 118.78)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB143"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB143",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_1038_6026",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(368.341 107.828) rotate(90) scale(48.7826 107.985)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB143"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB143",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_1038_6026",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(354.167 98.1658) rotate(90) scale(58.3162 94.0452)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB143"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB143",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_1038_6026",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(337.368 90.1807) rotate(90) scale(66.1592 77.4487)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB143"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB143",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_1038_6026",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(318.385 84.0841) rotate(90) scale(72.09 58.6199)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB143"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB143",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_1038_6026",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(297.724 80.0246) rotate(90) scale(75.9699 38.0633)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB143"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB143",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_1038_6026",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(276.073 78.1404) rotate(90) scale(77.6697 16.4613)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB143"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB143",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_1038_6026",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(246.858 78.1404) rotate(90) scale(77.6697 16.4613)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB143"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB143",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_1038_6026",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(225.201 80.0246) rotate(90) scale(75.9699 38.0633)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB143"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB143",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_1038_6026",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(204.54 84.0841) rotate(90) scale(72.09 58.6199)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB143"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB143",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_1038_6026",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(185.56 90.1807) rotate(90) scale(66.1592 77.4456)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB143"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB143",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_1038_6026",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(168.764 98.1658) rotate(90) scale(58.3162 94.0452)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB143"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB143",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_1038_6026",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(154.584 107.828) rotate(90) scale(48.7826 107.985)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB143"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB143",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_1038_6026",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(143.519 118.864) rotate(90) scale(37.8448 118.78)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB143"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB143",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_1038_6026",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(135.872 130.938) rotate(90) scale(25.8386 126.138)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB143"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB143",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_1038_6026",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(131.82 143.758) rotate(90) scale(13.0625 129.883)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB143"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB143",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_1038_6026",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(131.165 161.131) rotate(90) scale(6.522 130.378)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB143"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB143",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint29_radial_1038_6026",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(133.366 174.131) rotate(90) scale(19.4983 128.49)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB143"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB143",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial_1038_6026",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(139.279 186.653) rotate(90) scale(31.9633 122.879)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB143"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB143",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_radial_1038_6026",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(148.662 198.249) rotate(90) scale(43.4738 113.778)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB143"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB143",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint32_radial_1038_6026",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(161.345 208.615) rotate(90) scale(53.728 101.347)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB143"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB143",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint33_radial_1038_6026",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(176.834 217.458) rotate(90) scale(62.4363 86.079)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB143"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB143",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint34_radial_1038_6026",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(194.815 224.553) rotate(90) scale(69.3771 68.271)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB143"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB143",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint35_radial_1038_6026",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(214.729 229.645) rotate(90) scale(74.2978 48.4861)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB143"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB143",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint36_radial_1038_6026",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(235.953 232.637) rotate(90) scale(77.1092 27.3422)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB143"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB143",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1038_6026"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 521.35,
    height: 310.568,
    fill: "white",
    transform: "translate(0.787109 0.470703)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackshine);
export default __webpack_public_path__ + "static/media/backshine.a01423c2107e4fdfd28da24c721e0282.svg";
export { ForwardRef as ReactComponent };